import * as commonFun from '@editor/src/page/index/components/canvas/common';
import { RenderPostionType } from '@src/js/constant';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import ScaleElementWrapperPresenter from './scale-element-wrapper-presenter';
import React from 'react';
import classNames from 'classnames';
import connect from '@src/js/separate-logic/connect';
import { elementFromType } from '../element-types';
import styles from '@editor/src/page/index/components/canvas/slide.css';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import {
    isIframeShapeModel,
    isIframeShapeModelInTextMode,
    isMediaElement,
} from '@src/slide/domain/ui-model/elements/element-judge';
import { IMediaManager } from '@src/slide/application/service/media-manager/media-manager.interface';
import { advHas } from '@src/slide/infrastructure/module/independent/assert/get-set';
import _has from 'lodash/has';

interface IScaleElementWrapperProps{
    // 父组件props
    element: any;
    getPageScale: () => number;
    fromScale: number;
    mobileEditMode: any;
    serverRender: boolean;
    scale: number;
    region: string;

    // presenter props
    setRef: (name: string, ref: any) => void;
    getMediaManager(): IMediaManager | undefined;
}

export class ScaleElementWrapper extends React.Component<IScaleElementWrapperProps> {
    public static displayName = 'ScaleElementWrapper';

    public static defaultProps = {
        setRef: () => {},
    };

    // eslint-disable-next-line complexity
    public render() {
        const Element = elementFromType(this.props.element.type);
        if (!Element || this.shouldNotRenderIframeInCanvasMode()) {
            return null;
        }

        const classes = classNames({
            [styles.slideItem]: true,
            [styles.isCroping]: false,
        });
        const hasRotate =  advHas(this.props.element, 'props.style.rotate');
        const rect: any = {
            top: this.props.element.props.style.top,
            left: this.props.element.props.style.left,
            width: this.props.element.props.style.width,
            height: this.props.element.props.style.height,
            flipH: _has(this.props.element, 'props.style.flipH') ? this.props.element.props.style.flipH : 0,
            flipV: _has(this.props.element, 'props.style.flipV') ? this.props.element.props.style.flipV : 0,
            rotate: hasRotate ? this.props.element.props.style.rotate : 0,
        };

        if (this.props.element.type === UIModelType.IMAGE) {   // 图片要有裁图属性
            rect.srcRect = _has(this.props.element, 'srcRect.t') ? this.props.element.srcRect : this.props.element.props.style.srcRect;
        } else if (this.props.element.type === UIModelType.SHAPE
            && this.props.element.props.style.fillBackground
            && this.props.element.props.style.fillBackground.image
            && this.props.element.props.style.fillBackground.image.stretch) {
            rect.srcRect = _has(this.props.element, 'srcRect.t') ? this.props.element.srcRect : this.props.element.props.style.fillBackground.image.stretch.fillRect;
            if (rect.srcRect) {
                rect.srcRect = {
                    ...rect.srcRect,
                };
                if (!(rect.srcRect.l)) rect.srcRect.l = 0;
                if (!(rect.srcRect.r)) rect.srcRect.r = 0;
                if (!(rect.srcRect.t)) rect.srcRect.t = 0;
                if (!(rect.srcRect.b)) rect.srcRect.b = 0;
            }
        }

        return (
            <div
                key={this.props.element.key}
                className={classes}
                id={this.props.element.domId(RenderPostionType.LEFTLIST)}
                style={{
                    ...rect,
                    position: 'absolute',
                    transform: commonFun.transformOfRotate(rect),
                }}
                onTouchStart={(e) => {
                    if (this.props.element.props.addon || isMediaElement(this.props.element)) {
                        e.stopPropagation();
                    }
                }}
            >
                <Element
                    ref={(e) => {
                        this.props.setRef('elementRef', e);
                    }}
                    elementRootId={this.props.element.key}
                    component={this.props.element}
                    scale={this.props.scale}
                    getPageScale={this.props.getPageScale}
                    rect={rect}
                    fromScale={this.props.fromScale}
                    region={this.props.region}
                    rotate={this.props.element.props.style.rotate ? this.props.element.props.style.rotate : 0}
                    serverRender={this.props.serverRender}
                    mobileEditMode={this.props.mobileEditMode}
                />
            </div>
        );
    }

    private shouldNotRenderIframeInCanvasMode = () => {
        const { element } = this.props;

        return isIframeShapeModelInTextMode(element)
            || ((isIframeShapeModel(element) && !(this.props.getMediaManager()?.elementKey === element.key
                && this.props.getMediaManager()?.isShowIframe)) && !browser.isMobile);
    };
}

export default connect(
    ScaleElementWrapperPresenter,
    null,
    ScaleElementWrapper,
);
